import { IContentHubClient } from "../../clients/content-hub-client";
import Guard from "../../guard";
import { IEntityDefinitionQueryResult } from "./entity-definition-query-result";
import { IQueryIterator } from "./query-iterator";
import { SkipTakeIteratorBase } from "./skip-take-iterator-base";

/**
 * An iterator for iterating over IEntityDefinition query results.
 */
export type IEntityDefinitionIterator = IQueryIterator<IEntityDefinitionQueryResult>;

export class EntityDefinitionIterator
    extends SkipTakeIteratorBase<IEntityDefinitionQueryResult>
    implements IEntityDefinitionIterator
{
    private readonly _client: IContentHubClient;

    constructor(client: IContentHubClient, param: number | IEntityDefinitionQueryResult) {
        super(param);
        Guard.notNullOrUndefined(client);
        this._client = client;
    }

    async getResultAsync(skip: number, take: number): Promise<IEntityDefinitionQueryResult> {
        return await this._client.entityDefinitions.getRangeAsync(skip, take);
    }
}
